<template>
    <rkm-modal
        persistent
        ref="RkmModal"
        title="Autorização do supervisor"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.usuario"
                        label="Usuário"
                        v-model="model.usuario"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.senha"
                        label="Senha"
                        type="password"
                        v-model="model.senha"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="authorize"
                color="primary"
            >
                Autorizar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                usuario: {
                    required: true,
                    min: 3,
                },
                senha: {
                    required: true,
                    min: 8,
                },
            }
        },
    },
    created() {
        this.repositories = {
            autenticacao: this.getConectaSusRepository('administracao.autenticacao'),
            supervisor: this.getConectaSusRepository('regulacao.supervisor'),
        }
    },
    data: () => ({
        data: null,
        model: {
            usuario: null,
            senha: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(data = null) {

            this.resetForm()

            this.data = data

            this.$refs.RkmModal.show()
        },
        cancel() {

            this.$refs.RkmModal.hide()
            this.$emit('canceled')
        },
        authorize() {

            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    this.repositories.autenticacao.login(this.camelObjectKeysToSnakeRecursive(this.model))
                        .then(response => {
                            this.isSupervisor(response.data.usuario.id)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        isSupervisor(usuarioId) {

            this.setLoading()

            this.repositories.supervisor.isSupervisor(usuarioId)
                .then(({data}) => {
                    if (data) {
                        this.$refs.RkmModal.hide()
                        this.$emit('authorized', data)
                    } else {
                        this.showValidationNotification('O usuário informado não é um supervisor.')
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        resetForm() {

            this.model.usuario = null
            this.model.senha = null

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        }
    },
    mixins: [error, repository, stringCase],
}
</script>